export default "__VITE_ASSET__DAHIen$n__"